// import firebase from 'firebase';
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/functions";


import firebaseConfig from './fbConfig';
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";

var fire = initializeApp(firebaseConfig.config);
const fireDatabase = getDatabase(fire);
 const fireFunctions = getFunctions(fire);
        // connectFunctionsEmulator(fireFunctions, "127.0.0.1", 5001);
export {fireDatabase, fire, fireFunctions}

